<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" max-width="450" scrollable persistent>
			<v-card>
				<v-card-title class="text-h6">Kirim Ulang Serial</v-card-title>
				<v-card-text>
					<v-form ref="formEmail" role="form" @submit.prevent>
						<v-row>
							<v-col cols="12" class="pb-0">
								<v-text-field outlined dense v-model="email" :rules="emailRules" @focus="() => error_validation.email=''" :error-messages="error_validation.email" label="Email Tujuan"></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="batal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="send">Kirim</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import {mapState} from 'vuex'
export default {
	data () {
		return {
			dialog: false,
			emailRules: [
			value => !!value || 'Email tidak boleh kosong',
			],
			trx_id: '',
			email: '',
		}
	},
	computed: {
		...mapState(['error_validation']),
	},
	methods: {

		async showModal(trx_id, email) {
			this.trx_id = trx_id
			this.email = email
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
			this.trx_id = ''
			this.email = ''
		},
		batal() {
			this.hideModal()
		},
		send() {
			if (this.$refs.formEmail.validate()) {
				let params = {
					trx_id: this.trx_id,
					email: this.email,
				}
				this.$emit('action', params)
			}
		},
	},
}
</script>
